// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__uEimV","content":"styles_content__oHrY8","tableWrap":"styles_tableWrap__2Tcrg"};